import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { TranslateModule } from '@ngx-translate/core';

import { UIRouterModule } from '@uirouter/angular';

import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FileUploadAngularModule } from 'rev-shared/ui/fileUpload/FileUpload.AngularModule';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { SelectAngularModule } from 'rev-shared/ui/select/SelectAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { UtilAngularModule } from 'rev-shared/util/UtilAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';
import { VbToggleButtonComponent } from 'rev-shared/ui/buttons/VbToggleButton.Component';
import { VbUiCheckboxComponent } from 'rev-shared/ui/checkbox/VbUiCheckbox.Component';
import { VbUiRadioBtnDirective } from 'rev-shared/ui/buttons/VbUiRadioBtnAngular.Directive';
import { VbUiRadioBtnGroupDirective } from 'rev-shared/ui/buttons/VbUiRadioBtnGroupAngular.Directive';
import { VbUiTextInputDirective } from 'rev-shared/ui/textInput/VbUiTextInput.Directive';
import { VbUserPreferenceStoreDirective } from 'rev-shared/userPreference/VbUserPreferenceStore.Directive';
import { Video360IndicatorModule } from 'rev-shared/media/video360Indicator/Video360Indicator.AngularModule';
import { VideoTranscribeAndAiMetadataComponent } from 'rev-shared/videoAiMetadata/VideoTranscribeAndAiMetadata.Component';

import { RecordingAngularModule } from 'rev-portal/media/recording/RecordingAngular.Module';
import { VbrickImportModule } from 'rev-portal/media/import/Import.Module';

import { UploadMenuComponent } from './UploadMenu.Component';
import { UploadFileComponent } from './UploadFile.Component';

const components = [
	UploadMenuComponent,
	UploadFileComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		DateAngularModule,
		DialogAngularModule,
		DirectivesAngularModule,
		FileUploadAngularModule,
		FormGroupAngularModule,
		FormsModule,
		RecordingAngularModule,
		SecurityAngularModule,
		SelectAngularModule,
		SpinnerAngularModule,
		TabsModule,
		TranslateModule,
		UIRouterModule.forChild(),
		UtilAngularModule,
		ValidationAngularModule,
		ValidationModule,
		VbBtnPrimaryDirective,
		VbToggleButtonComponent,
		VbUiCheckboxComponent,
		VbUiRadioBtnDirective,
		VbUiRadioBtnGroupDirective,
		VbUiTextInputDirective,
		VbUserPreferenceStoreDirective,
		VbrickImportModule,
		Video360IndicatorModule,
		VideoTranscribeAndAiMetadataComponent
	]
})

export class UploadMenuModule {}
